import React from "react";
import PropTypes from "prop-types";
import { FacilityCards } from "components/search/FacilityCards";
import { FacilityPageSection } from "components/facility/FacilityPageSection";

const NearbyFacilitiesSection = ({ facilities }) => {
	if (!facilities || facilities.length === 0) return null;
	return (
		<FacilityPageSection
			title="Nearby Storage Facilities"
			isCollapsable={false}
			defaultOpen
			autoHeight
		>
			<FacilityCards
				cards={facilities}
				layout="narrow"
			/>
		</FacilityPageSection>
	);
};
NearbyFacilitiesSection.propTypes = {
	facilities: PropTypes.arrayOf(PropTypes.object)
};

export default NearbyFacilitiesSection;
